import { Component, Inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from '../../environments/environment';
import { appVersion } from '../app.version'


export interface DialogData {
    name: string;
}

@Component({
    selector: 'app-info-popup',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        MatButtonModule
    ],
    templateUrl: 'app-info-popup.component.html',
    styleUrl: 'app-info-popup.component.css'
})
export class AppInfoPopup {

    protected appName = environment.appName;
    protected appVersion = appVersion;
    
    public constructor(@Inject(MatDialogRef) public matDialogRef: MatDialogRef<AppInfoPopup>,
                       @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    }

    public close(): void {
        this.matDialogRef.close();
    }
}
